import React from 'react';
import PropTypes from 'prop-types';

import { testId } from 'ui-components/services/testid-service';

import style from './help-menu-dropdown.module.less';
import HelpMenuSectionItem, { HelpMenuSectionItemPropTypes } from './help-menu-section-item';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

const HelpMenuSection = ({ header = emptyObject, items = emptyArray }) => {
  if (!items || items.length === 0) {
    return null;
  }
  return (
    <div>
      <div className={style['drop-down-header']}>
        <div className={style['header-name']} {...testId(header.testId)}>
          {header.text}
        </div>
      </div>
      {items
        .filter((item) => !!item)
        .map((item) => (
          <HelpMenuSectionItem {...item} key={item.testId} />
        ))}
    </div>
  );
};

HelpMenuSection.propTypes = {
  header: PropTypes.shape({
    text: PropTypes.node,
    testId: PropTypes.string,
  }),
  items: PropTypes.arrayOf(PropTypes.shape(HelpMenuSectionItemPropTypes)),
};

export default HelpMenuSection;
